// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3-O3G","modalForm":"UpgradeEpcsModal_modalForm__2CtYp","modalFooter":"UpgradeEpcsModal_modalFooter__15rd6"};